
export default function TargetCustomers() {
  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-6">
            Khách Hàng Mục Tiêu
          </h2>
          <p className="text-xl md:text-2xl text-gray-800 max-w-3xl mx-auto font-semibold">
            Chúng tôi chuyên phục vụ các đối tác B2B trong ngành du lịch
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Customer Type 1 */}
          <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 text-center border-t-4 border-blue-900">
            <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-building-line text-blue-900 text-4xl"></i>
            </div>
            <h3 className="text-2xl font-extrabold text-gray-900 mb-4">
              Công Ty Du Lịch
            </h3>
            <p className="text-lg text-gray-800 leading-relaxed font-semibold">
              Các công ty tổ chức tour du lịch Mỹ từ Việt Nam, cần đối tác vận chuyển uy tín tại địa phương.
            </p>
          </div>

          {/* Customer Type 2 */}
          <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 text-center border-t-4 border-red-600">
            <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-ticket-line text-red-600 text-4xl"></i>
            </div>
            <h3 className="text-2xl font-extrabold text-gray-900 mb-4">
              Phòng Vé
            </h3>
            <p className="text-lg text-gray-800 leading-relaxed font-semibold">
              Các đại lý bán vé máy bay, tour trọn gói, cần dịch vụ đưa đón và vận chuyển cho khách hàng.
            </p>
          </div>

          {/* Customer Type 3 */}
          <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 text-center border-t-4 border-green-600">
            <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-graduation-cap-line text-green-600 text-4xl"></i>
            </div>
            <h3 className="text-2xl font-extrabold text-gray-900 mb-4">
              Công Ty Du Học
            </h3>
            <p className="text-lg text-gray-800 leading-relaxed font-semibold">
              Tổ chức đưa đón học sinh, sinh viên tham quan các trường đại học và thành phố tại Mỹ.
            </p>
          </div>

          {/* Customer Type 4 */}
          <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 text-center border-t-4 border-purple-600">
            <div className="w-20 h-20 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-team-line text-purple-600 text-4xl"></i>
            </div>
            <h3 className="text-2xl font-extrabold text-gray-900 mb-4">
              Tổ Chức Đoàn
            </h3>
            <p className="text-lg text-gray-800 leading-relaxed font-semibold">
              Các tổ chức, doanh nghiệp, hội nhóm cần thuê xe cho chuyến công tác, hội nghị, sự kiện tại Mỹ.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
